"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Speaker = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Speaker = function Speaker() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 22.5v-21A1.5 1.5 0 0015 0h-.885a1.5 1.5 0 00-1.05.435L7.32 6.18A4.5 4.5 0 014.14 7.5a2.64 2.64 0 00-2.64 2.64v3.72a2.64 2.64 0 002.64 2.64 4.5 4.5 0 013.18 1.32l5.745 5.745a1.5 1.5 0 001.05.435H15a1.5 1.5 0 001.5-1.5zm4.26-14.4a.81.81 0 01.54.3v.075a6 6 0 010 7.2.765.765 0 01-1.125 0l-1.08-1.08a.75.75 0 01-.09-.945 3 3 0 000-3.3.75.75 0 01.09-.945l1.08-1.08a.765.765 0 01.585-.225z"
  });
};

exports.Speaker = Speaker;